import EMBEDDED_END_USER_TOKEN_STORAGE_KEY from './embeddedEndUserTokenStorageKey.js';

// Deletes copies written to localStorage before the token moved to
// sessionStorage. Nothing reads them; this only stops a live bearer token from
// sitting in the browser. Delete this file two weeks after the move ships, when
// every token issued before it has expired.
const removeLegacyEmbeddedEndUserToken = () => {
  try {
    localStorage.removeItem(EMBEDDED_END_USER_TOKEN_STORAGE_KEY);
  } catch {
    /* restricted storage */
  }
};

export default removeLegacyEmbeddedEndUserToken;
